module.exports = __webpack_public_path__ + "static/img/watermelon.9c3d233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/watermelon.png
// module id = FdSL
// module chunks = 1